import Rotaion from './Rotaion.vue';

export default Rotaion;
